// NEW STEP CARD

import * as React from "react";
import { Stepper, Step, StepLabel, Typography, Card, useMediaQuery } from "@mui/material";
import styles from "./stepperStyle.module.css";
import { getStepStatus } from './StepperComponents'
import { useSelector } from "react-redux";
import { MobileStepper } from './MobileStepper'; // for mobile

const StepperCard = ({
  activeStep,
  handleStepNavigate,
  backendResponse,
  CustomStepConnector,
  StepIcon,
  steps
}) => {
 
  const isMobile = useMediaQuery('(max-width:1000px)'); // for mobile
  
  const { userData, panVerified, aadharVerified } = useSelector((state) => state.user);

  // CURSOR STYLE FOR NON CLICKABLE STEP PAN AND DIGI
  const getCursorStyle = (step) => {
    if (step.path === "/step-1" && 
        ((panVerified === "true" || userData?.steps?.["Pan Verify"]?.status) ))
        // &&
        // (aadharVerified === "true" || userData?.steps?.["Aadhaar Verify"]?.status)))
         {
        return "default";
    }
    if (step.path === "/step-2" && 
        (userData?.steps?.["DigiLocker KYC verified Docs"]?.status)) {
        return "default";
    }
    return "pointer";
  };

  
  // Determine completed and skipped steps 
  // for mobile
  const completedSteps = React.useMemo(() => 
    steps.reduce((acc, step, index) => {
      const status = getStepStatus(step, backendResponse);
      return status.completed ? [...acc, index] : acc;
    }, []),
    [steps, backendResponse]
  );

  // for mobile
  const skippedSteps = React.useMemo(() => 
    steps.reduce((acc, step, index) => {
      const status = getStepStatus(step, backendResponse);
      return status.skipped ? [...acc, index] : acc;
    }, []),
    [steps, backendResponse]
  );


  if (isMobile) {
    return (
      <Card className={styles.mobileStepperCard} sx={{
        backgroundColor: 'transparent', // ✅ transparent background
        boxShadow: 'none' ,// optional: remove card shadow for full transparency look
        padding: '8px',
        // marginBottom: '16px'

      }}>
        <MobileStepper 
          activeStep={activeStep}
          steps={steps}
          completedSteps={completedSteps}
          skippedSteps={skippedSteps}
        />
        {/* <Typography variant="h6" sx={{ 
          color: '#000', 
          mt: 2,
          textAlign: 'center'
        }}>
          {steps[activeStep]?.description}
        </Typography> */}
      </Card>
    );
  }

  return (
    <Card className={styles.stepperCardStyle} sx={{
      background: "linear-gradient(180deg, #2D184F 0%, #251323 100%)",
    }}>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        connector={<CustomStepConnector />}
      >
        {steps.map((step, index) => {
          const status = getStepStatus(step, backendResponse);
          const isCompleted = status.completed;
          const isSkipped = status.skipped;

          return (
            <Step
              key={step.label || step.description}
              onClick={() => {
                                // Don't allow navigation to PAN verify if already completed
                if (step.path === "/step-1" && ((panVerified === "true" || userData?.steps?.["Pan Verify"]?.status)))
                  //  &&
                // (aadharVerified === "true" || userData?.steps?.["Aadhaar Verify"]?.status))) 
                {
                    return;
                }
                                // Don't allow navigation to DigiLocker if already completed
                if (step.path === "/step-2" && (userData?.steps?.["DigiLocker KYC verified Docs"]?.status)) {
                    return;
                }
                handleStepNavigate(step.path);
              }}
              sx={{
                "& :hover":{
                  cursor: getCursorStyle(step), 
                },
                "& .MuiStepLabel-root": {
                      borderRadius: "40px 0px 0px 40px !important",
                      backgroundColor:
                          index === activeStep ? "#ffffff" : "transparent",
                      transition: "background-color 0.3s ease",
                      padding:
                          index === activeStep && "18px 0px 14px 28px !important",
                      paddingLeft: "28px !important",
                  },
              }}
            >
              <StepLabel
                StepIconComponent={(props) => (
                    <StepIcon
                        {...props}
                        stepIndex={index}
                        isCompleted={isCompleted}
                        isSkipped={isSkipped}
                    />
                )}
                sx={{
                    "&.MuiStepLabel-label": {
                        display: "none",
                        paddingLeft: "28px !important",
                    },
                }}
              >
                <Typography
                    sx={{
                        color: index === activeStep ? "#000" : "#ffffff",
                        fontSize: "16px !important",
                        textAlign: "left",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        fontFamily:
                            activeStep === index
                                ? "Inter700 !important"
                                : "Inter400 !important",
                    }}
                >
                    {step.description}
                </Typography>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Card>
  );
};

export default StepperCard;



